import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import {
	PrepareOneSchemaShareAssociationsCacheDto,
	UpsertShareAssociationsDto,
} from '@dealstack/shared/lib/generated';

export const prepareOneSchemaShareAssociationsCache = async (
	args: PrepareOneSchemaShareAssociationsCacheDto
) => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: API_PATHS.ONE_SCHEMA_INVESTMENT_ALLOCATIONS_PREPARE_CACHE_POST,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args),
	}).then((response) => response.payload);
};

export const upsertShareAssociations = async (mipId: string, args: UpsertShareAssociationsDto) => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(
			API_PATHS.MIP_MIPID_INVESTOR_INVESTMENT_WORKFLOW_BULK_UPDATE_ALLOCATIONS_POST,
			{ mipId }
		),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args),
	}).then((response) => response.payload);
};
